import uuid from "react-uuid";

export const formatAddUpdateCertificateRequestPayload = ({ values, compState, user, addCertificate, certificateDetails, selectedCertImageData }) => {
    const { employeeNumber: employeeID, firstName, lastName, businessUnit: businessUnitID, businessUnitName = '' } = user;
    const payload = {
        employeeID,
        firstName,
        lastName,
        stateCode: "",
        businessUnitID,
        businessUnitName,
        certificateID: "245",
        documentNumber: "Test2",
        lotNumber: "",
        doseNumber: "",
        isVaccineDeclined: "",
        manufacturer: "",
        countyName: "",
        agency: "",
        certificateImage: "",
        isActive: "Active",
        submitSource: "Portal",
        jobTitle: "",
        dataSource: "",
        disposition: "",
        fileIDFront: "",
        fileID: "",
        fileIDBack: "",
        employeeCertificatesID: "",
        ...values,
        ...((Number(values.certificateID) === 1007 || Number(values.certificateID) === 259) ? { isVaccineDeclined: values.isVaccineDeclined ? "1" : "0" } : {}),
        ...(Number(values.certificateID) === 1007 ? { doseNumber: values.vaccineBooster ? "Yes" : "No" } : {}),
        frontImage: Array.isArray(values.frontImage) ? values.frontImage[0].original : values.frontImage,
        backImage: Array.isArray(values.backImage) ? values.backImage[0].original : values.backImage,
        certificateImage: Array.isArray(values.certificateImage) ? values.certificateImage[0].original : values.certificateImage,
        certificateName: compState.certificateTypesOptions.find(v => Number(v.value) === Number(values.certificateID))?.label,
        isExpiring: compState?.selectedCertificate?.isExpCert === "True",
        submissionID: uuid(),
        updateSource: "Portal",
        createdBy: `${firstName} ${lastName} (${employeeID})`,
    };
    if (values.zipCode.length > 0) {
        payload.documentNumber = `${values.documentNumber}:${values.zipCode}`;
        delete payload.zipCode;
    }
    if (/* (addCertificate) ||  */!addCertificate && (Array.isArray(values.frontImage) || Array.isArray(values.backImage)))
        delete payload.certificateImage;
    delete payload.vaccineBooster;
    if (Number(values.certificateID) !== 1007) {
        delete payload.certStatus;
        delete payload.manufacturer;
        delete payload.lotNumber;
        if (Number(values.certificateID) !== 259)
            delete payload.isVaccineDeclined;
    }

    if (!addCertificate) {
        payload.issueDate = payload?.issueDate || certificateDetails.issueDate;
        payload.expirationDate = payload?.expirationDate || certificateDetails.expirationDate;
        if (!(payload.frontImage || payload.backImage))
            payload.certificateImage = payload.certificateImage || `data:${selectedCertImageData.certificateType};base64,` + selectedCertImageData.certificateImage;
    }

    return payload;
}

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));